import { MenuItem } from "primereact/menuitem"
import { useState } from "react"

const useSteps = (steps: MenuItem[]) => {
    const [stepIndex, setStepIndex] = useState(0)
    function nextStep() {
        if (steps.length - 1 == stepIndex) return
        setStepIndex((prev) => prev + 1)
    }

    function prevStep() {
        if (stepIndex == 0) return
        setStepIndex((prev) => prev - 1)
    }

    return { stepIndex, nextStep, prevStep, resetSteps: () => setStepIndex(0) }
}

export default useSteps